export default function formatUSPhone(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length !== 10) return phone; // fallback

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}



// WEBPACK FOOTER //
// ./src/utils/phoneUtil.js